import { BREAKPOINT } from '@ab-core/breakpoints';
import { useIsMobile } from '@ab-core/functions';
import { useAuth } from '@ab-core/hooks';
import { Search } from '@ab-core/search';
import type { FC } from 'react';
import React from 'react';
import { Brand } from '../components/brand';
import { Cart } from '../components/cart';
import { SalesView } from '../components/salesView';
import { MobileBarWrapper } from './index.styled';

type MobileProps = { searchString?: string; pathname: string };

export const Mobile: FC<MobileProps> = (props) => {
    const { searchString, pathname } = props;
    const { user } = useAuth();
    const isMobileSmartPhone = useIsMobile(BREAKPOINT.SM);

    return (
        <MobileBarWrapper>
            <Brand />
            <Search searchString={searchString} />

            {!isMobileSmartPhone && <SalesView />}

            {user && <Cart pathname={pathname} />}
        </MobileBarWrapper>
    );
};
